import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error: error };
    }

    componentDidCatch(error, info) {
        // Guarded: getAnalytics() throws when Firebase has not initialized, and a
        // throw inside componentDidCatch would take out the boundary itself.
        try {
            logEvent(getAnalytics(), 'ERROR_BOUNDARY', {
                route: this.props.route,
                error: String(error),
                info: info?.componentStack,
            });
        } catch (analyticsError) {
            console.warn('ERROR_BOUNDARY telemetry unavailable', analyticsError);
        }

        console.error(info, error);
    }

    render() {
        if (this.state.error && this.props.fallback) {
            return this.props.fallback({ retry: () => this.setState({ error: null }) });
        }
        if (this.state.error) {
            const route = this.props.route || '';
            const isDeckRoute = route.includes('details');
            const recoveryCopy = isDeckRoute
                ? 'Please try re-importing the deck you were trying to view. If that does not work, please let us know in the discord. Thanks!'
                : 'Please try reloading the page. If that does not work, please let us know in the discord. Thanks!';
            return (
                <div
                    style={{
                        fontSize: '1rem',
                        fontWeight: 'bolder',
                        textAlign: 'center',
                        marginTop: '50px',
                        color: '#FFF',
                    }}
                >
                    <img
                        alt=""
                        style={{ maxWidth: '90vw' }}
                        src={
                            'https://cards.scryfall.io/art_crop/front/5/2/52558748-6893-4c72-a9e2-e87d31796b59.jpg?1559959349'
                        }
                    />
                    <span style={{ maxWidth: '90vw' }}>
                        <p>Whoops! Something broke here.</p>
                    </span>
                    <p />
                    <span style={{ maxWidth: '90vw', fontSize: '1rem' }}>
                        <p>{recoveryCopy}</p>
                    </span>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
